import { render, staticRenderFns } from "./ReceivingDownload.vue?vue&type=template&id=52226ae2&scoped=true"
import script from "./ReceivingDownload.vue?vue&type=script&lang=js"
export * from "./ReceivingDownload.vue?vue&type=script&lang=js"
import style0 from "./ReceivingDownload.vue?vue&type=style&index=0&id=52226ae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52226ae2",
  null
  
)

export default component.exports